'use strict';

import voyadoAnalytics from './analytics/voyado';

export const VOYADO_EVENT_TRACK_PRODUCT_IMPRESSION = voyadoAnalytics.VOYADO_EVENT_TRACK_PRODUCT_IMPRESSION;
export const VOYADO_EVENT_MONITOR_CART = voyadoAnalytics.VOYADO_EVENT_MONITOR_CART;
export const VOYADO_EVENT_MONITOR_EMPTY_CART = voyadoAnalytics.VOYADO_EVENT_MONITOR_EMPTY_CART;
export const VOYADO_SCRIPT_LOADED = voyadoAnalytics.VOYADO_SCRIPT_LOADED;
export const loadAnalytics = voyadoAnalytics.execute;
